import React, { useState, useEffect } from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { CircularProgress } from "@mui/material";
import { components } from "react-select";
import { connect } from "react-redux";
import { Radio } from "antd";
import validator from "validator";
import moment from "moment";

import { customInput } from "../../../../components/common/custom-input";
import { CustomSingleSelect } from "../../../../components/common/new-core-ui/CustomSingleSelect";
import { CustomRangePicker } from "../../../../components/common/customRangePicker";
import { CustomTimePicker } from "../../../../components/common/customTimePicker";
import CustomRadioGroupV2 from "../../../../components/common/new-core-ui/CustomRadioGroupV2";
import { weekDayOptions } from "../BookTaskUtils";
import { plannedShiftTypes } from "../../../../utils/common";

import styles from "../../v2Styles.module.css";
import v2FormSelectStyle from "../../v2FormSelectStyle";

export const validatePlannedShiftForm = (values) => {
  const errors = {};
  if (!values.tasks || (values.tasks && values.tasks.length === 0)) {
    errors.tasks = "Required";
  }
  if (!values.applicable_period) {
    errors.applicable_period = "Required";
  }
  if (!values.start_time) {
    errors.start_time = "Required";
  }
  if (!values.end_time) {
    errors.end_time = "Required";
  }
  if (!values.duration || (values.duration && moment(values.duration).format("HH:mm") === "00:00")) {
    errors.duration = "Required";
  }
  if (!values.copy_across) {
    errors.copy_across = "Required"
  }
  if (values.copy_across && values.copy_across === "Instance" && !values.instance_day) {
    errors.instance_day = "Required"
  }
  if (!values.staff || (values.staff && !validator.isNumeric(values.staff.toString(), { no_symbols: true })) || (values.staff && !isNaN(values.staff) && parseInt(values.staff) < 1)) {
    errors.staff = "Required"
  }
  return errors;
}

let PlanJobShiftsForm = ({ tasks, handleSubmit, pristine, initialValues, duration, startTime, change, copyAcross, onSubmit, isUpdate = false, reset, onFormCancel }) => {

  const [submitting, setSubmitting] = useState(false);
  const isDisabled = isUpdate && (!initialValues || !initialValues.id);
  const isDateDisabled = false;

  const [isNextDay, setIsNextDay] = useState(false);

  const onCancel = () => {
    onFormCancel();
    reset();
  }

  const onFormSubmit = (values) => {
    onSubmit(values);
    reset();
  }

  useEffect(() => {
    if (duration && startTime) {
      let durationVal = new moment(duration);
      let endDate = new moment(startTime).add(durationVal.hour(), "hours").add(durationVal.minutes(), "minutes");
      if (moment(startTime).date() !== endDate.date()) {
        setIsNextDay(true);
      } else {
        setIsNextDay(false);
      }
      change("end_time", endDate);
    } else {
      change("end_time", startTime);
      setIsNextDay(false);
    }
  }, [duration, startTime])

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-9">
            <div className={styles.Label}>Tasks</div>
            <Field name="tasks"
              component={CustomSingleSelect}
              options={tasks.map(x => ({ label: x.task_name, value: x.id }))}
              otherProps={{
                isDisabled: submitting || isDisabled,
                isMulti: true,
                hideSelectedOptions: false,
                closeMenuOnSelect: false,
                components: { dropdownIndicator: <components.DownChevron /> },
              }}
              styles={v2FormSelectStyle}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3 pt-2">
            <div className={styles.Label}>Staff</div>
            <Field
              name="staff"
              component={customInput}
              type="number"
              className={styles.TextField}
              otherProps={{
                format: "hh:mm A",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3 pt-2">
            <div className={styles.Label}>Start Time</div>
            <Field
              name="start_time"
              component={CustomTimePicker}
              className="calendar-v2-time-picker w-100"
              disabled={submitting || isDisabled}
              // dropdownClassName="cs-datepicker-dropdown"
              allowClear
              otherProps={{
                format: "hh:mm A",
              }}
            />
          </div>
          <div className="col-3 pt-2">
            <div className={styles.Label}>Duration ( HH:MM )</div>
            <Field
              name="duration"
              component={CustomTimePicker}
              className="calendar-v2-time-picker w-100"
              dropdownClassName="cs-datepicker-dropdown"
              allowClear
              disabled={submitting || isDisabled}
              otherProps={{
                format: "HH:mm",
              }}
            />
          </div>
          <div className="col-3 pt-2">
            <div className={styles.Label}>End Time</div>
            <Field
              name="end_time"
              component={CustomTimePicker}
              className="calendar-v2-time-picker w-100"
              dropdownClassName="cs-datepicker-dropdown"
              allowClear
              disabled
              otherProps={{
                format: "hh:mm A",
              }}
            />
            {isNextDay ? <div style={{ position: "absolute", fontSize: "12px" }}>
              <div className="">+1 Day - Overnight Shift </div>
            </div> : null}
          </div>
          <div className="col-3 pt-2">
            <div className={styles.Label}>Shift Type</div>
            <Field
              name="shift_type"
              component={CustomSingleSelect}
              options={Object.values(plannedShiftTypes)}
              otherProps={{
                isDisabled: submitting || isDisabled,
                hideSelectedOptions: false,
                components: { dropdownIndicator: <components.DownChevron /> },
              }}
              styles={v2FormSelectStyle}
            />
          </div>
        </div>
        <div className="row pt-2">
          <div className="col-4">
            <div className={styles.Label}>Applicable Period</div>
            <Field
              name="applicable_period"
              component={CustomRangePicker}
              className="cs-filter-range-picker w-100 text-center"
              dropdownClassName="cs-datepicker-dropdown"
              allowClear
              disabled={submitting || isDisabled}
              otherProps={{
                format: "DD-MM-YYYY",
                disabledDate: isDateDisabled
              }}
              showTime={false}
            />
          </div>
          <div className="col-3">
            <div className={styles.Label}>Copy Across</div>
            <Field name="copy_across" component={CustomRadioGroupV2} defaultValue={"Series"}>
              <div className="pb-2 d-flex align-items-end pt-1" style={{ gap: "10px" }}>
                <Radio disabled={submitting || isDisabled} className="cs-radio-v2" value={"Instance"}>Instance</Radio>
                <Radio disabled={submitting || isDisabled} className="cs-radio-v2" value={"Series"}>Series</Radio>
              </div>
            </Field>
          </div>
        </div>
        <div className="row">
          {copyAcross && copyAcross === "Instance" ? (
            <div className="col-4 pt-2">
              <div className={styles.Label}>Day of Instance</div>
              <Field name="instance_day"
                component={CustomSingleSelect}
                options={weekDayOptions.map(x => ({ label: x, value: x }))}
                otherProps={{
                  isDisabled: submitting || isDisabled,
                  components: { dropdownIndicator: <components.DownChevron /> },
                }}
                styles={v2FormSelectStyle}
              />
            </div>) : null}
        </div>
        <div className="row">
          <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
            {submitting ? (<CircularProgress size={20} />) : null}
            <button type="button" disabled={isDisabled} onClick={onCancel} className={styles.OutlinedButton}>Cancel</button>
            <button type="submit" disabled={submitting || pristine || isDisabled} className={styles.PrimaryButton}>{(initialValues && initialValues.id) || isUpdate ? "Update Shift" : "Add Shift"}</button>
          </div>
        </div>
      </div>
    </form>
  )
}

PlanJobShiftsForm = reduxForm({
  form: "plan_job_shifts_form",
  destroyOnUnmount: true,
  enableReinitialize: true,
  validate: validatePlannedShiftForm
})(PlanJobShiftsForm)

PlanJobShiftsForm = connect((state) => ({
  startTime: (formValueSelector("plan_job_shifts_form"))(state, "start_time"),
  duration: (formValueSelector("plan_job_shifts_form"))(state, "duration"),
  copyAcross: (formValueSelector("plan_job_shifts_form"))(state, "copy_across")
}))(PlanJobShiftsForm)

export default PlanJobShiftsForm;